import { render, staticRenderFns } from "./FormGenitor.vue?vue&type=template&id=dd13ff04&"
import script from "./FormGenitor.vue?vue&type=script&lang=js&"
export * from "./FormGenitor.vue?vue&type=script&lang=js&"
import style0 from "./FormGenitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports